import api from './index';

export default {
  index(params) {
    return api({
      method: 'get',
      url: `api/movements`,
      params,
    });
  },
  create(data) {
    return api({
      method: 'post',
      url: `api/movements`,
      data,
    });
  },
  getById(id, params) {
    return api({
      method: 'get',
      url: `api/movements/${id}`,
      params,
    });
  },
  accept(id, data) {
    return api({
      method: 'post',
      url: `api/movements/${id}/accept`,
      data,
    });
  },
  update(id, data) {
    return api({
      method: 'put',
      url: `api/movements/${id}`,
      data,
    });
  },
  // createAccounts(id, data) {
  //   return api({
  //     method: 'post',
  //     url: `api/movements/${id}/accounts`,
  //     data,
  //   });
  // },
};
